import { createI18n } from 'vue-i18n'

import en from './locales/en.json'
import fr from './locales/fr.json'

export default createI18n({
  locale: window.APP_CONFIG.VITE_DEFAULT_LOCALE,
  fallbackLocale: window.APP_CONFIG.VITE_FALLBACK_LOCALE,
  legacy: false,
  messages: {
    en,
    fr
  }
})
